import { createContext } from '@lit/context';
import { RateQuoteFormData } from '../util/form';

export const formDataContext = createContext<RateQuoteFormData>(Symbol('formData'));
